import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
// import DashboardLayer from "../../components/Dashboard/DashboardLayer";
import Breadcrumb from "../../components/Breadcrumb";
import DashboardLayer from "../../components/DashboardV2/DashboardLayer";


const DashboardPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title="Shipora" />


                {/* DashBoardLayerOne */}
                {/* <DashboardLayer /> */}

                <DashboardLayer/>

            </MasterLayout>
        </>
    );
};

export default DashboardPage;
